import { render, staticRenderFns } from "./ZDMActionList.vue?vue&type=template&id=3c8f2f16&scoped=true&"
import script from "./ZDMActionList.vue?vue&type=script&lang=js&"
export * from "./ZDMActionList.vue?vue&type=script&lang=js&"
import style0 from "./ZDMActionList.vue?vue&type=style&index=0&id=3c8f2f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f2f16",
  null
  
)

export default component.exports